import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';

const getErrorMessage = (error, fallback) => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;
    const msg =
      (typeof data?.message === 'string' && data.message) ||
      (typeof data?.detail === 'string' && data.detail) ||
      (typeof data?.error === 'string' && data.error) ||
      error.message;
    return msg || fallback;
  }
  if (error instanceof Error) return error.message;
  return fallback;
};

/**
 * POST /api/auth/cms/login
 * Body: { email, password }
 * On success, returns response data (may include token, user, etc.)
 */
export const login = async (email, password) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/auth/cms/login`, {
      email: email.trim(),
      password,
    });
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error, 'Login failed. Please check your credentials.'));
  }
};
